import { SWAN_STYLE_KEY_MAP } from "@vp/swan";

export const SWAN_STYLE_KEYS = [SWAN_STYLE_KEY_MAP.pricing, SWAN_STYLE_KEY_MAP.popover, SWAN_STYLE_KEY_MAP.modalDialog, SWAN_STYLE_KEY_MAP.accordion, SWAN_STYLE_KEY_MAP.selectionSet];
